import React from 'react';
import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';

interface DraftReviewNoticeProps {
  kind: 'created' | 'changed';
  /** What the AI says it did, if it said anything. */
  summary?: string;
  onGoToSave: () => void;
  onUndo: () => void;
}

/** "Review and save" cue shown above the form after AI has filled it in. */
export const DraftReviewNotice: React.FC<DraftReviewNoticeProps> = ({ kind, summary, onGoToSave, onUndo }) => (
  <Alert
    id="ai-draft-review"
    severity="success"
    sx={{ mb: 3, alignItems: 'flex-start' }}
    action={
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        <Button size="small" color="inherit" onClick={onUndo}>
          {kind === 'created' ? 'Start over' : 'Undo change'}
        </Button>
        <Button size="small" variant="contained" color="success" onClick={onGoToSave}>
          Go to Save
        </Button>
      </Box>
    }
  >
    <AlertTitle sx={{ fontWeight: 700 }}>
      {kind === 'created' ? 'Your draft is ready. Review it, then save.' : 'Change applied to the form. Review it, then save.'}
    </AlertTitle>
    <Typography variant="body2">
      Check the name, instructions and output format below and edit anything you like. It is not saved yet.
      {kind === 'created' && ' Once saved, you can test it right on this page.'}
    </Typography>
    {summary && (
      <Typography variant="body2" sx={{ mt: 1, whiteSpace: 'pre-wrap' }}>
        <strong>What AI did:</strong> {summary}
      </Typography>
    )}
  </Alert>
);

export default DraftReviewNotice;
